/* src/app/component/pages/pages.component.css */
/*# sourceMappingURL=pages.component.css.map */
